import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Layout from './Layout';
import { useTheme } from '../context/ThemeContext';
import { NavLink as RouterLink } from 'react-router-dom';
import MemberInfoImg from '../nav logo/inputmemberinfo-removebg-preview.png';
import ProfileInfo from '../nav logo/visitor-removebg-preview.png';
import Profile from '../nav logo/profile2-removebg-preview.png';

function NewMember() {
  const { isDark } = useTheme();

  // Add this at the top with other useState hooks
  const [profileImage, setProfileImage] = useState(Profile); // Default image
  const [visitType, setVisitType] = useState('first'); // 'first' | 'second'

  useEffect(() => {
    const savedImage = localStorage.getItem('profileImage');
    if (savedImage) {
      setProfileImage(savedImage);
    }
  }, []);

  // Image change handler
  const handleImageChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setProfileImage(base64);
        localStorage.setItem('profileImage', base64); // <-- Save here
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Layout title="Add New Member">
        <div className="p-2">
          {/* Header + Desktop Dark Mode Toggle */}
          <div className="flex justify-between items-start mb-6">
            <div className="flex items-center gap-3">
              <h1 className="text-indigo-900 font-bold text-xl dark:text-indigo-100">
                Add New Member
              </h1>
            </div>

            <NavLink to="/member">
              <h1 className="text-green-900 font-bold text-xs mt-2 dark:text-yellow-400">
                &gt; Back to Members
              </h1>
            </NavLink>
            <RouterLink to="/visitors" className="ml-auto">
              <span className="text-xs bg-indigo-600 text-white px-3 py-2 rounded-md">Import from Visitors</span>
            </RouterLink>
          </div>

          {/* Form Card */}
          <div className="bg-white w-full shadow-2xl p-4 border-t-4 border-indigo-600 rounded-t-xl">
            <div className="flex gap-4">
              <img src={MemberInfoImg} alt="" className="bg-green-800 w-12 h-12 rounded-full p-1" />
              <h1 className="text-gray-500 mt-2 font-semibold">
                Please fill in the member details below.
              </h1>
            </div>

            <div className="flex mt-6 gap-2 ml-2">
              <img src={ProfileInfo} alt="" className="w-6 h-6 bg-green-900 rounded-full mt-2" />
              <h1 className="text-gray-700 mt-2 font-bold">Personal Information</h1>
            </div>

            {/* Visit type selector */}
            <div className="mt-4 flex gap-3">
              <button
                type="button"
                onClick={() => setVisitType('first')}
                className={`${visitType === 'first' ? 'bg-indigo-600 text-white' : 'bg-indigo-50 text-indigo-700'} px-4 py-2 rounded-xl font-semibold`}
              >
                🆕 I'm a First Timer
              </button>
              <button
                type="button"
                onClick={() => setVisitType('second')}
                className={`${visitType === 'second' ? 'bg-indigo-600 text-white' : 'bg-indigo-50 text-indigo-700'} px-4 py-2 rounded-xl font-semibold`}
              >
                🔁 I've Been Here Before
              </button>
            </div>

            <div className="mt-6 ml-0 md:ml-7 flex flex-wrap gap-3 w-full">
              <div className="w-full md:w-1/4 max-w-sm">
                <label htmlFor="title" className="block text-gray-600 font-semibold">
                  Title*
                </label>
                <select
                  id="title"
                  className="border-2 bg-white text-gray-500 font-semibold border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                >
                  <option value="">Select Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                  <option value="Dr">Dr</option>
                  <option value="Prof">Prof</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="w-full md:w-1/4 max-w-sm">
                <label htmlFor="Firstname" className="block text-gray-600 font-semibold">
                  FirstName*
                </label>
                <input
                  type="text"
                  id="Firstname"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                  placeholder="FirstName"
                />
              </div>
              <div className="w-full md:w-1/4 max-w-sm">
                <label htmlFor="Lastname" className="block text-gray-600 font-semibold">
                  LastName*
                </label>
                <input
                  type="text"
                  id="Lastname"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                  placeholder="LastName"
                />
              </div>
              <div className="w-full md:w-1/4 max-w-sm">
                <label htmlFor="EmailAddress" className="block text-gray-600 font-semibold">
                  Email Address*
                </label>
                <input
                  type="email"
                  id="EmailAddress"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                  placeholder="EmailAddress"
                />
              </div>
            </div>

            <div className="mt-6 ml-0 md:ml-7 flex flex-wrap gap-3 w-full">
              <div className="w-full md:w-1/3 max-w-sm">
                <label htmlFor="PhoneNumber" className="block text-gray-600 font-semibold">
                  Phone Number*
                </label>
                <input
                  type="tel"
                  id="PhoneNumber"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                  placeholder="XXX XXX XXXX"
                />
              </div>
              <div className="w-full md:w-1/3 max-w-sm">
                <label htmlFor="dob" className="block text-gray-600 font-semibold">
                  Date Of Birth*
                </label>
                <input
                  type="date"
                  id="dob"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2 text-gray-500 font-semibold"
                />
              </div>
              <div className="w-full md:w-1/3 max-w-sm">
                <label htmlFor="Gender" className="block text-gray-600 font-semibold">
                  Gender*
                </label>
                <select
                  id="Gender"
                  className="border-2 bg-white text-gray-500 font-semibold border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            <div className="mt-6 ml-0 md:ml-7 flex flex-wrap gap-3 w-full">
              <div className="w-full md:w-1/3 max-w-sm">
                <label htmlFor="MaritalStatus" className="block text-gray-600 font-semibold">
                  Marital Status*
                </label>
                <select
                  id="MaritalStatus"
                  className="border-2 bg-white text-gray-500 font-semibold border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                >
                  <option value="">Select Status</option>
                  <option value="single">Single</option>
                  <option value="married">Married</option>
                  <option value="separated">Separated</option>
                  <option value="divorced">Divorced</option>
                  <option value="single_parent">Single Parent</option>
                  <option value="widowed">Widowed</option>
                </select>
              </div>
              <div className="w-full md:w-1/3 max-w-sm">
                <label htmlFor="ageGroup" className="block text-gray-600 font-semibold">
                  Age Group*
                </label>
                <select
                  id="ageGroup"
                  className="border-2 bg-white text-gray-500 font-semibold border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                >
                  <option value="">Select Age Group</option>
                  <option value="13-19">13-19</option>
                  <option value="20-29">20-29</option>
                  <option value="30-39">30-39</option>
                  <option value="40-49">40-49</option>
                  <option value="50-59">50-59</option>
                  <option value="60+">60+</option>
                </select>
              </div>
              <div className="w-full md:w-1/3 max-w-sm">
                <label htmlFor="occupation" className="block text-gray-600 font-semibold">
                  Occupation*
                </label>
                <input
                  type="text"
                  id="occupation"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2 text-gray-500 font-semibold"
                  placeholder="Occupation"
                />
              </div>
            </div>

            <div className="mt-6 ml-0 md:ml-7 flex flex-wrap gap-3 w-full">
              <div className="w-full md:w-1/2 max-w-sm">
                <label htmlFor="location" className="block text-gray-600 font-semibold">
                  Location/Address*
                </label>
                <input
                  type="text"
                  id="location"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2 text-gray-500 font-semibold"
                  placeholder="Location/Address"
                />
              </div>
              <div className="w-full md:w-1/2 max-w-sm">
                <label htmlFor="howHeard" className="block text-gray-600 font-semibold">
                  How did you hear about us?*
                </label>
                <select
                  id="howHeard"
                  className="border-2 bg-white text-gray-500 font-semibold border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                >
                  <option value="">Select Option</option>
                  <option value="friend_family">Friend/Family</option>
                  <option value="billboard">Billboard</option>
                  <option value="flyer">Flyer</option>
                  <option value="tv_radio">TV/Radio</option>
                  <option value="social_media">Social Media</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            {/* Dynamic sections based on visit type */}
            {visitType === 'first' ? (
              <div className="mt-4 ml-0 md:ml-7 flex flex-wrap gap-3 w-full">
                <div className="w-full">
                  <label className="block text-gray-600 font-semibold">Prayer requests</label>
                  <textarea rows={3} className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2" placeholder="Please share your prayer requests..." />
                </div>
                <div className="w-full">
                  <label className="block text-gray-600 font-semibold">Feedback/Comments</label>
                  <textarea rows={3} className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2" placeholder="Please share your feedback about the service..." />
                </div>
              </div>
            ) : (
              <div className="mt-4 ml-0 md:ml-7 flex flex-wrap gap-3 w-full">
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">When was your first time?</label>
                  <input type="date" className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2" />
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">Did you receive a call, text or visit?</label>
                  <select className="border-2 bg-white text-gray-600 border-gray-400 border-dotted rounded-md p-2 w-full mt-2">
                    <option value="">Select Option</option>
                    <option value="call">Call</option>
                    <option value="text">Text</option>
                    <option value="visit">Visit</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">Have you been baptized?</label>
                  <select className="border-2 bg-white text-gray-600 border-gray-400 border-dotted rounded-md p-2 w-full mt-2">
                    <option value="">Select Option</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">Would you like to be baptized?</label>
                  <select className="border-2 bg-white text-gray-600 border-gray-400 border-dotted rounded-md p-2 w-full mt-2">
                    <option value="">Select Option</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">Would you like to join the workforce?</label>
                  <select className="border-2 bg-white text-gray-600 border-gray-400 border-dotted rounded-md p-2 w-full mt-2">
                    <option value="">Select Option</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">Preferred department</label>
                  <select className="border-2 bg-white text-gray-600 border-gray-400 border-dotted rounded-md p-2 w-full mt-2">
                    <option value="">Select Department</option>
                    <option value="throne_room_priests">Throne Room Priests</option>
                    <option value="ushering">Ushering</option>
                    <option value="protocol">Protocol</option>
                    <option value="technical_media">Technical/Media</option>
                    <option value="children_department">Children's Department</option>
                    <option value="counselling">Counselling</option>
                    <option value="sunday_school">Sunday School</option>
                    <option value="follow_up">Follow Up</option>
                    <option value="prayer_department">Prayer Department</option>
                    <option value="evangelism">Evangelism</option>
                  </select>
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">Preferred time of day for visit</label>
                  <select className="border-2 bg-white text-gray-600 border-gray-400 border-dotted rounded-md p-2 w-full mt-2">
                    <option value="">Select Time</option>
                    <option value="morning">Morning</option>
                    <option value="afternoon">Afternoon</option>
                    <option value="evening">Evening</option>
                  </select>
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">Preferred day of week for visit</label>
                  <select className="border-2 bg-white text-gray-600 border-gray-400 border-dotted rounded-md p-2 w-full mt-2">
                    <option value="">Select Day</option>
                    <option value="sunday">Sunday</option>
                    <option value="monday">Monday</option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="saturday">Saturday</option>
                  </select>
                </div>
                <div className="w-full md:w-1/2 max-w-sm">
                  <label className="block text-gray-600 font-semibold">If RCCG member before, which parish?</label>
                  <input className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2" placeholder="Parish name" />
                </div>
                <div className="w-full">
                  <label className="block text-gray-600 font-semibold">Visit notes</label>
                  <textarea rows={3} className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2" placeholder="Additional notes for follow-up..." />
                </div>
              </div>
            )}

            {/* Profile Image Upload */}
            <div className="flex flex-col items-center mt-10">
              <div className="w-32 h-32 rounded-full p-1 bg-gradient-to-r from-green-800 to-yellow-200">
                <div className="relative w-full h-full rounded-full overflow-hidden bg-white">
                  <img
                    src={profileImage}
                    alt="Profile"
                    className="w-full h-full object-cover rounded-full"
                  />
                  <label
                    htmlFor="upload"
                    className="absolute bottom-1 right-1 bg-yellow-500 p-1 rounded-full cursor-pointer shadow"
                  >
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </label>
                  <input
                    id="upload"
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleImageChange}
                  />
                </div>
              </div>

              <p className="text-sm text-gray-500 mt-2">Click icon to change profile photo</p>
              <p className="text-sm text-gray-500 mt-2">Accepted formats: JPG, PNG or GIF</p>
            </div>
            <hr className="mt-5" />
            <h1 className="text-indigo-900 font-bold mt-4 text-xl">Emergency Contact Information</h1>
            <div className="flex flex-wrap gap-3 mt-6 ml-0 md:ml-7 w-full">
              <div className="w-full md:w-1/2 max-w-sm">
                <label htmlFor="EmergencyName" className="block text-gray-600 font-semibold">
                  Emergency Contact Name*
                </label>
                <input
                  type="text"
                  id="EmergencyName"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                  placeholder="Name"
                />
              </div>
              <div className="w-full md:w-1/2 max-w-sm">
                <label htmlFor="EmergencyPhone" className="block text-gray-600 font-semibold">
                  Emergency Contact Phone*
                </label>
                <input
                  type="tel"
                  id="EmergencyPhone"
                  className="border-2 border-gray-400 border-dotted rounded-md p-2 w-full mt-2"
                  placeholder="XXX XXX XXXX"
                />
              </div>
            </div>

            <hr className="mt-5" />
            <div className="bg-white  rounded-xl shadow p-4 mt-6 w-full">
              <h2 className="text-indigo-900 dark:text-indigo-100 font-bold mb-4 text-sm">
                Church Information
              </h2>

              <div className="flex flex-col md:flex-row md:gap-4">
                <div className="mb-4 w-full">
                  <label
                    htmlFor="membershipStatus"
                    className="block text-sm font-medium text-gray-700  mb-1"
                  >
                    Membership Status
                  </label>
                  <select
                    id="membershipStatus"
                    className="w-full p-2 border border-gray-300 rounded-md bg-white "
                  >
                    <option value="">Select Status</option>
                    <option value="full">Full Member</option>
                    <option value="associate">Associate Member</option>
                    <option value="guest">Guest</option>
                  </select>
                </div>

                <div className="mb-4 w-full">
                  <label
                    htmlFor="department"
                    className="block text-sm font-medium text-gray-700  mb-1"
                  >
                    Department
                  </label>
                  <select
                    id="department"
                    className="w-full p-2 border border-gray-300 rounded-md bg-white "
                  >
                    <option value="">Select Department</option>
                    <option value="throne_room_priests">Throne Room Priests</option>
                    <option value="ushering">Ushering</option>
                    <option value="protocol">Protocol</option>
                    <option value="technical_media">Technical/Media</option>
                    <option value="children_department">Children's Department</option>
                    <option value="counselling">Counselling</option>
                    <option value="sunday_school">Sunday School</option>
                    <option value="follow_up">Follow Up</option>
                    <option value="prayer_department">Prayer Department</option>
                    <option value="evangelism">Evangelism</option>
                  </select>
                </div>
              </div>

              <div className="flex flex-col md:flex-row md:gap-4">
                <div className="mb-4 w-full">
                  <label
                    htmlFor="baptismStatus"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Baptism Status
                  </label>
                  <select
                    id="baptismStatus"
                    className="w-full p-2 border border-gray-300 rounded-md bg-white "
                  >
                    <option value="">Select Baptism Status</option>
                    <option value="baptized">Baptized</option>
                    <option value="notBaptized">Not Baptized</option>
                  </select>
                </div>
              </div>
            </div>
            <hr className="mt-4" />
            <div className="flex gap-3">
              <NavLink to="/member">
                <h1 className="text-gray-500 font-bold rounded-md bg-white border-2 border-dotted border-gray-400 w-20 p-2 text-center text-xs mt-2">
                  Cancel
                </h1>
              </NavLink>
              <NavLink to="/member">
                <h1 className="text-white font-bold text-xs bg-indigo-700 p-2 w-20 text-center rounded-md mt-2">
                  Save
                </h1>
              </NavLink>
            </div>
          </div>
        </div>
    </Layout>
  );
}

export default NewMember;
